export default __webpack_public_path__ + "static/eye_wash_b.9687e1dabf2994edc6ef4276c903eb4f.png";